var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var MyChartDischargeSummaryDetailsCard_1;
import { Avatar, Card } from '@philips-internal/oswald-ui-components';
import { SelectionType, Size, Type } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import React, { Component } from 'react';
import MyChartDischargeSummaryCardAPI from './my-chart-discharge-summary-details-card-api';
import discharge from '../../assets/images/icons/discharge.svg';
import externalTransfer from '../../assets/images/icons/external-transfer.svg';
import './my-chart-discharge-summary-details-card.css';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import SummaryType from '../../constants/summary-type';
const DISCHARGE_LABEL = 'patient.my.chart.label.discharge';
const EXTERNAL_TRANSFER_LABEL = 'patient.my.chart.label.external.transfer';
let MyChartDischargeSummaryDetailsCard = MyChartDischargeSummaryDetailsCard_1 = class MyChartDischargeSummaryDetailsCard extends Component {
    static { this.propTypes = {
        uuid: string,
    }; }
    static { this.defaultProps = {
        width: 12,
    }; }
    findTagLabel() {
        const { summaryType } = this.props;
        if (!summaryType) {
            return '';
        }
        return summaryType === SummaryType.DISCHARGE ? MessageService.translate(DISCHARGE_LABEL) : MessageService.translate(EXTERNAL_TRANSFER_LABEL);
    }
    findTagColorLabel() {
        const { summaryType } = this.props;
        if (!summaryType) {
            return Type.NEUTRAL;
        }
        return summaryType === SummaryType.DISCHARGE ? Type.SAFETY : Type.WARNING;
    }
    findAvatarImage() {
        const { summaryType } = this.props;
        if (!summaryType) {
            return '';
        }
        return summaryType === SummaryType.DISCHARGE ? discharge : externalTransfer;
    }
    hideImage() {
        const { summaryType } = this.props;
        return !summaryType ? true : false;
    }
    render() {
        const { image, doctorName, uuid, specialty, width = MyChartDischargeSummaryDetailsCard_1.defaultProps.width } = this.props;
        return (React.createElement(Card, { uuid: uuid, selectionType: SelectionType.NONE, className: "my-chart-card-details-summary", width: width, transparent: false },
            React.createElement("div", { className: "card-content" },
                React.createElement("div", { className: "avatar-area avatar-area-doctor" },
                    React.createElement(Avatar, { title: doctorName, subtitle: specialty, image: image ? `data:image/png;base64,${image}` : image }))),
            React.createElement("div", { className: "card-content area-tag" },
                React.createElement("div", { className: "avatar-area" },
                    React.createElement(Avatar, { image: this.findAvatarImage(), size: Size.XSMALL, hideImage: this.hideImage(), title: this.findTagLabel() })))));
    }
};
MyChartDischargeSummaryDetailsCard = MyChartDischargeSummaryDetailsCard_1 = __decorate([
    AwesomeComponent({ api: MyChartDischargeSummaryCardAPI, type: ComponentType.DATA_DISPLAY })
], MyChartDischargeSummaryDetailsCard);
export default MyChartDischargeSummaryDetailsCard;
//# sourceMappingURL=my-chart-discharge-summary-details-card.js.map